import { createAction } from '../../../Common/_actions/Action';
import { type PurchaseReportPayload } from '../../_stores/Store/PurchaseReportStore';

export enum StorePurchaseReportActionType {
	EditPurchaseReportData = 'STORE_PURCHASE_REPORT_EDIT_PURCHASE_REPORT_DATA',
}

export const EditPurchaseReportData = (store: string, report: PurchaseReportPayload) => createAction(StorePurchaseReportActionType.EditPurchaseReportData, {
	store: store,
	report: report,
});

export type StorePurchaseReportAction =
	ReturnType<typeof EditPurchaseReportData>
